export default {
  getchangeLostDialog (state) {
    return state.changeLostDialog
  },
  getchangeSaveUpdateDialog (state) {
    return state.changeSaveUpdateDialog
  },
  formType (state) {
    return state.FORM_TYPE
  },
  getuserDetails (state) {
    return state.userDetails
  },
  getUsers (stateObj) {
    return stateObj.listOfUsers
  },
  getListOfGroups (stateObj) {
    return stateObj.listOfGroups
  },
  listOfModules (stateObj) {
    return stateObj.listOfModules
  }
}
